import * as React from "react";

export default function Loading() {
    return <div className="h-[75px] w-full flex justify-center items-center">
        <div
            className="spinner-border border-y-transparent animate-spin border-default-900 inline-block w-8 h-8 border-2 rounded-full"
            role="status"
        >

        </div>
    </div>
}